export const IS_PRODUCTION: boolean = process.env.NODE_ENV === 'production'
export const INJ_GAS_FEE = 0.002
